import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=5b610f9a"
import script from "./DateInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DateInput.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports